import "./sliders"

const menuTogllerEl = document.querySelector('.js-menu-togller');
const menuEl = document.querySelector('.js-menu');

if(menuTogllerEl && menuEl) {
  menuTogllerEl.addEventListener('click', () => {
    menuEl.classList.toggle('js-active');
    menuTogllerEl.classList.toggle('js-active');
    document.body.classList.toggle('js-menu-active');
  })
}
